// src/themes/default/utils/productColorIcon.tsx
import { Scale, Container, Package, Boxes, CupSoda, type LucideIcon } from 'lucide-react';
import { getSiteConfig } from '@/core/config/theme-config';

// فقط تو سایت شمشک (که تمش eram هست و برای کامپوننت‌هایی مثل ProductCard/
// ProductInformation به تمِ default فال‌بک می‌کنه)، بجای رنگِ واقعیِ گزینه (که
// برای بسته‌بندی معنی نداره)، بر اساس اسمِ گزینه (کیلویی/سطلی/کارتنی/بسته‌ای/
// دانه‌ای) یه آیکون متناسب نشون می‌دیم. محصولات شمشک (ترشک/آلوچه) تو ظرف‌های
// لیوانی، کارتن، و... عرضه می‌شن، پس آیکون‌ها متناسب با همون بسته‌بندی واقعی‌ان،
// نه یه معادل عمومی مبلمانی. بقیه‌ی سایت‌هایی که از تمِ eram/default استفاده
// می‌کنن دست‌نخورده می‌مونن.
const IS_SHEMSHAK_SITE = getSiteConfig().siteName === 'shemshak';

const PACKAGING_ICON_RULES: [match: string, icon: LucideIcon][] = [
  ['کیلو', Scale],
  ['سطل', Container],
  ['کارتن', Package],
  ['بسته', Boxes],
  ['دانه', CupSoda],
];

export function getPackagingIcon(label?: string | null): LucideIcon | null {
  if (!IS_SHEMSHAK_SITE || !label) return null;
  const rule = PACKAGING_ICON_RULES.find(([match]) => label.includes(match));
  return rule ? rule[1] : null;
}
